import "./Legal.css";

export default function TermsOfService() {
  return (
    <div className="legal-page">
      <h1>Termos de Serviço</h1>
      <p className="legal-date">Última atualização: 25 de março de 2026</p>

      <p>
        Bem-vindo ao <strong>ViewsDay</strong>. Ao acessar ou utilizar nossa plataforma, você concorda com os
        presentes Termos de Serviço ("Termos"). Leia-os atentamente antes de utilizar o serviço.
      </p>

      <h2>1. Definições</h2>
      <ul>
        <li><strong>Plataforma:</strong> o aplicativo e o site do ViewsDay, incluindo todas as funcionalidades disponibilizadas.</li>
        <li><strong>Usuário:</strong> qualquer pessoa física que se cadastre e utilize a Plataforma.</li>
        <li><strong>Serviço:</strong> a geração e entrega de resumos de vídeos do YouTube por inteligência artificial, conforme os canais selecionados pelo Usuário.</li>
        <li><strong>Conteúdo:</strong> os resumos, análises e demais materiais gerados pela Plataforma.</li>
      </ul>

      <h2>2. Descrição do Serviço</h2>
      <p>
        O ViewsDay é uma plataforma que utiliza inteligência artificial para gerar resumos de vídeos publicados
        em canais do YouTube selecionados pelo Usuário. Os resumos são entregues via WhatsApp, Telegram ou
        outros canais de comunicação, no horário definido pelo Usuário.
      </p>
      <p>
        Os resumos são gerados automaticamente por IA e têm caráter informativo. O ViewsDay não garante a
        precisão, completude ou atualidade das informações contidas nos resumos.
      </p>

      <h2>3. Cadastro e Conta</h2>
      <ul>
        <li>Para utilizar o Serviço, você deve criar uma conta fornecendo um endereço de e-mail válido e uma senha.</li>
        <li>Você é responsável por manter a confidencialidade das suas credenciais de acesso.</li>
        <li>Você deve fornecer informações verdadeiras e atualizadas no cadastro.</li>
        <li>Você deve ter pelo menos 18 (dezoito) anos de idade ou a maioridade civil em sua jurisdição.</li>
        <li>Cada Usuário pode manter apenas uma conta ativa na Plataforma.</li>
      </ul>

      <h2>4. Planos e Pagamentos</h2>
      <p>
        O ViewsDay oferece planos gratuitos e pagos. Os planos pagos são cobrados de forma recorrente
        (mensal ou anual), conforme o plano escolhido.
      </p>
      <ul>
        <li>Os preços estão sujeitos a alterações, com aviso prévio de 30 (trinta) dias.</li>
        <li>
          O Usuário pode cancelar sua assinatura a qualquer momento. O acesso aos recursos do plano pago
          será mantido até o final do período já pago.
        </li>
        <li>
          Em conformidade com o Art. 49 do Código de Defesa do Consumidor, o Usuário tem direito ao
          arrependimento no prazo de 7 (sete) dias após a contratação, com reembolso integral.
        </li>
        <li>Reembolsos após o prazo de arrependimento serão analisados caso a caso.</li>
      </ul>

      <h2>5. Uso Aceitável</h2>
      <p>Ao utilizar a Plataforma, você se compromete a não:</p>
      <ul>
        <li>Utilizar o Serviço para fins ilegais ou não autorizados.</li>
        <li>Reproduzir, distribuir ou comercializar os resumos gerados sem autorização.</li>
        <li>Tentar acessar sistemas, dados ou contas de outros Usuários sem autorização.</li>
        <li>Utilizar bots, scrapers ou outros meios automatizados para acessar a Plataforma de forma abusiva.</li>
        <li>Interferir no funcionamento da Plataforma ou de seus servidores.</li>
        <li>Violar direitos de propriedade intelectual de terceiros.</li>
      </ul>

      <h2>6. Propriedade Intelectual</h2>
      <p>
        Todo o conteúdo da Plataforma, incluindo mas não limitado a textos, design, logotipos, código-fonte e
        marca ViewsDay, é de propriedade do ViewsDay ou de seus licenciadores e está protegido pelas leis de
        propriedade intelectual brasileiras e tratados internacionais.
      </p>
      <p>
        Os resumos gerados pela IA são fornecidos como ferramenta de conveniência. Os vídeos originais e seus
        conteúdos permanecem de propriedade dos respectivos criadores no YouTube.
      </p>

      <h2>7. Isenção de Garantias</h2>
      <p>
        O Serviço é fornecido "no estado em que se encontra" (<em>as is</em>). Embora nos esforcemos para manter
        a qualidade e a disponibilidade, não garantimos:
      </p>
      <ul>
        <li>Que o Serviço será ininterrupto, seguro ou livre de erros.</li>
        <li>A precisão ou completude dos resumos gerados por inteligência artificial.</li>
        <li>Que os resultados obtidos pelo uso do Serviço atenderão a todas as suas expectativas.</li>
      </ul>

      <h2>8. Limitação de Responsabilidade</h2>
      <p>
        Na máxima extensão permitida pela legislação brasileira e respeitados os direitos do consumidor:
      </p>
      <ul>
        <li>
          O ViewsDay não se responsabiliza por decisões tomadas com base nos resumos gerados pela Plataforma.
        </li>
        <li>
          O ViewsDay não se responsabiliza por danos indiretos, incidentais ou consequenciais decorrentes do
          uso ou impossibilidade de uso do Serviço.
        </li>
        <li>
          A responsabilidade total do ViewsDay, quando aplicável, será limitada ao valor pago pelo Usuário
          nos últimos 12 (doze) meses.
        </li>
      </ul>

      <h2>9. Suspensão e Encerramento</h2>
      <ul>
        <li>
          Podemos suspender ou encerrar sua conta caso você viole estes Termos, mediante notificação prévia
          quando possível.
        </li>
        <li>Você pode encerrar sua conta a qualquer momento através das configurações da Plataforma ou por e-mail.</li>
        <li>
          Após o encerramento, seus dados serão tratados conforme descrito em nossa{" "}
          <a href="/privacy">Política de Privacidade</a>.
        </li>
      </ul>

      <h2>10. Alterações nos Termos</h2>
      <p>
        Reservamo-nos o direito de alterar estes Termos a qualquer momento. Notificaremos você sobre alterações
        significativas por e-mail ou aviso na Plataforma com antecedência mínima de 30 (trinta) dias.
        O uso continuado do Serviço após as alterações constitui aceitação dos novos Termos.
      </p>

      <h2>11. Legislação Aplicável e Foro</h2>
      <p>
        Estes Termos são regidos pela legislação da República Federativa do Brasil, incluindo o Código de
        Defesa do Consumidor (Lei nº 8.078/1990), o Marco Civil da Internet (Lei nº 12.965/2014) e a
        Lei Geral de Proteção de Dados (Lei nº 13.709/2018).
      </p>
      <p>
        Para a resolução de quaisquer controvérsias decorrentes destes Termos, fica eleito o foro do
        domicílio do Usuário, conforme o Art. 101, I, do Código de Defesa do Consumidor.
      </p>

      <h2>12. Contato</h2>
      <div className="legal-contact">
        <p><strong>ViewsDay</strong></p>
        <p>E-mail: <a href="mailto:contact@views-day.com">contact@views-day.com</a></p>
        <p>Para dúvidas sobre estes Termos de Serviço, entre em contato pelo e-mail acima.</p>
      </div>
    </div>
  );
}
